<template>
    <div
        class="killerBg absolute z-10 flex h-full w-full flex-col items-center justify-end gap-1 p-8"
    >
        <img
            src="@/assets/images/games/killer/killerIndicatorBars.svg"
            :alt="$t('killer.bars_alt')"
            class="absolute bottom-0 left-0 max-w-1/3"
        />
        <img
            src="@/assets/images/games/killer/killerIndicatorBars.svg"
            :alt="$t('killer.bars_alt')"
            class="absolute right-0 bottom-0 max-w-1/3 -scale-x-100"
        />
        <img
            src="@/assets/images/games/killer/killerTurnBg.svg"
            class="absolute h-full max-w-[unset]"
        />

        <h2 class="font-title font-bold text-white uppercase">{{ profile?.tag_name }}</h2>

        <div class="relative flex max-w-40 p-8">
            <img
                src="@/assets/images/games/killer/killerProfileFrame.svg"
                :alt="$t('killer.dart_alt')"
                class="absolute top-0 left-0 -z-10 h-full w-full"
            />
            <img v-avatar-fallback="profile?.avatar" class="clip-left-bottom-corner h-23 w-40 bg-[#989898]" />
        </div>

        <img src="@/assets/images/games/killer/youAreKiller.svg" class="my-12 w-full" />

        <svg
            width="111px"
            height="102px"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            style="
                fill-rule: evenodd;
                clip-rule: evenodd;
                stroke-linejoin: round;
                stroke-miterlimit: 2;
            "
            class="mt-6 mb-14"
        >
            <g transform="matrix(1,0,0,1,-0.248172,36.999)">
                <g transform="matrix(1,0,0,1,0.220828,-36.999)">
                    <path
                        d="M83.084,101.999L60.704,101.999L60.704,83.28L49.609,83.28L49.609,101.999L27.229,101.999L27.229,83.28L6.665,83.28C3.021,83.28 0.051,80.272 0.051,76.577L0.051,12.033C0.051,8.337 3.021,5.33 6.665,5.33L103.636,5.33C107.279,5.33 110.25,8.337 110.25,12.033L110.25,76.577C110.25,80.272 107.279,83.28 103.636,83.28L83.071,83.28L83.071,101.999L83.084,101.999ZM61.872,100.827L81.916,100.827L81.916,82.107L103.649,82.107C106.645,82.107 109.095,79.622 109.095,76.577L109.095,12.033C109.095,8.987 106.657,6.502 103.649,6.502L6.677,6.502C3.681,6.502 1.231,8.987 1.231,12.033L1.231,76.577C1.231,79.622 3.669,82.107 6.677,82.107L28.41,82.107L28.41,100.827L48.454,100.827L48.454,82.107L61.885,82.107L61.885,100.827L61.872,100.827Z"
                        :style="{ fill: 'url(#_Linear1)' }"
                    />
                </g>
                <g transform="matrix(1,0,0,1,0.220828,-36.999)">
                    <path
                        d="M0.04,6.117L0.04,70.661C0.04,74.037 2.769,76.777 6.133,76.777L27.51,76.777L27.51,95.497L48.951,95.497L48.951,76.777L61.353,76.777L61.353,95.497L82.794,95.497L82.794,76.777L104.171,76.777C107.535,76.777 110.264,74.037 110.264,70.661L110.264,6.117C110.264,2.74 107.535,0 104.171,0L6.121,0C2.757,0 0.027,2.74 0.027,6.117L0.04,6.117ZM42.109,43.135L12.011,43.135L12.011,30.163L42.109,30.163L42.109,43.135ZM47.174,55.076L55.159,45.455L63.143,55.076L47.174,55.076ZM98.306,43.135L68.208,43.135L68.208,30.163L98.306,30.163L98.306,43.135Z"
                        :style="{ fill: 'url(#_Linear2)' }"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="_Linear1"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(110.199,0,0,110.199,0.0634755,53.6647)"
                >
                    <stop :stop-color="getLighterColor(resolvedColor, 20)" offset="0" />
                    <stop :stop-color="getDarkerColor(resolvedColor, 30)" offset="1" />
                </linearGradient>
                <linearGradient
                    id="_Linear2"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(110.329,83.2253,-83.2253,110.329,1.81724,-1.70758)"
                >
                    <stop :stop-color="getLighterColor(resolvedColor, 20)" offset="0" />
                    <stop :stop-color="getDarkerColor(resolvedColor, 30)" offset="1" />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>

<script>
import { getDarkerColor, getLighterColor } from '@/utils/colorHelpers'

export default {
    name: 'KillerTurnSplash',
    props: {
        profile: {
            type: Object,
            required: false,
            default: null,
        },
        color: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        resolvedColor() {
            return this.color || '#3F3F3F'
        },
    },
    methods: {
        getDarkerColor(color, amount) {
            return getDarkerColor(color || this.resolvedColor, amount)
        },
        getLighterColor(color, amount) {
            return getLighterColor(color || this.resolvedColor, amount)
        },
    },
}
</script>
